import api from "../../api/v1/index"

export const state = () => ({
    balance: null,
    items: [],
    paginator: {
        links:[],
        first_page_url:null,
        last_page_url: null,
        prev_page_url:null,
        next_page_url:null,
        from:null,
        to:null,
        total:null,
    },
})

export const actions = {
    getMsReport({commit}, data) {
        return api.mutual_settlement.report(data).then(
            response => {
                commit('updateReport', response)
                return Promise.resolve(response)
            },
            error => Promise.reject(error)
        )
    },

    getMsReportFile({commit}, data) {
        return api.mutual_settlement.file(data).then(
            response => {
                commit('')
                return Promise.resolve(response)
            },
            error => Promise.reject(error)
        )
    },

    addPayment({commit}, data){
        return api.mutual_settlement.add(data).then(
            response => {
                commit('addPayment', response)
                return Promise.resolve(response)
            },
            error => Promise.reject(error)
        )
    },

    removePayment({commit}, data){
        return api.mutual_settlement.remove(data).then(
            response => {
                commit('removePayment', data)
                return Promise.resolve(response)
            },
            error => Promise.reject(error)
        )
    },
}

export const mutations = {
    updateReport(state, data){
        state.balance = data.balance
        state.items = data.report.data.reverse()
        Object.keys(state.paginator)
            .forEach(el => state.paginator[el] = data.report[el])
    },

    removePayment(state, data){
        let index = state.items.findIndex(e => e.id === data.id);
        state.items.splice(index, 1)
    },
}

export const getters = {
    report_paginator(state){
        return state.paginator
    },

    report(state) {
        return state.items
    },

    report_balance(state){
        return state.balance / 100
    }
}